module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_2-97e5832f2668c2fba1b8053c83e2b5fc.webp";